import { ContentLoader } from "@bca/ui-library";

const LoadingSearch: React.FunctionComponent = () => {
  return (
    <ContentLoader width="280px" height="48px">
      <rect width={240} height={48} rx={12} ry={12}></rect>
      <rect width={240} height={48} x={12} rx={12} ry={12}></rect>
    </ContentLoader>
  );
};

export default LoadingSearch;
